module.exports = __webpack_public_path__ + "img/zrnf_qr.a69f803e.png";